<template>
	<div class="business-category-chooser">
		<select class="form-select form-select-sm" v-model="selected" @change="onChange" :disabled="loading">
			<option :value="''">— All categories —</option>
			<option v-for="cat in categories" :key="cat.id" :value="String(cat.id)">{{ cat.name }}</option>
		</select>
		<small v-if="loading" class="text-muted">Loading categories…</small>
		<small v-else-if="!categories.length" class="text-muted">No categories yet. Create some in Settings → Business Directory.</small>
	</div>
</template>

<script>
import juniperApi from '@/api/juniperApi'

export default {
	name: 'BusinessCategoryChooser',
	props: {
		value: {
			type: [String, Number],
			default: '',
		},
	},
	data() {
		return {
			categories: [],
			loading: false,
			selected: this.value !== undefined && this.value !== null ? String(this.value) : '',
		}
	},
	watch: {
		value(newVal) {
			this.selected = newVal !== undefined && newVal !== null ? String(newVal) : ''
		},
	},
	mounted() {
		this.fetchCategories()
	},
	methods: {
		async fetchCategories() {
			const clientId = this.$route && this.$route.params && this.$route.params.id
			if (!clientId) return
			this.loading = true
			try {
				const { data } = await juniperApi.get('/business-directory-categories', {
					params: { client_id: clientId },
				})
				this.categories = Array.isArray(data) ? data : []
			} catch (e) {
				this.categories = []
			} finally {
				this.loading = false
			}
		},
		onChange() {
			this.$emit('input', this.selected)
			this.$emit('change', this.selected)
		},
	},
}
</script>
